

export const msg =
'系统会先进行数据校验和款项分摊，需要几分钟的时间。您可以点击下方按钮查看系统处理进度。完成后将生成'
export const approvalMsg =
'系统会先进行数据校验和款项分摊，需要几分钟的时间。您可以点击下方按钮查看系统处理进度。完成后会将分摊结果提交审批流，审批通过后生成'


export const ConstantMapper = new Map([
  ['receivable', {
    title: '收款单。',
    toPath: 'receivableImportHistory',
  }],
  ['payment', {
    title: '付款单。',
    toPath: 'paymentImportHistory',
  }],
])
